import { FGListen, FGSelectInput, FGTextInput, FieldGroup, useFGContext } from "nsitools-react";
import * as React from "react";
import { ClubApi, CountryApi } from "../../../../../api";
import { FGCountrySelect, FGSRSHCheckboxInput } from "../../../../../components";

import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { useRequest } from "ahooks";

export interface IDrupalCompetitionClubAddressProps {
  postCodes: any;
  ploading: boolean;
}

export const DrupalCompetitionClubAddress: React.FunctionComponent<IDrupalCompetitionClubAddressProps> = ({
  postCodes,
  ploading,
}) => {
  const { t } = useTl();
  const countryApi = useApiService(CountryApi);
  const clubApi = useApiService(ClubApi);

  const { formik } = useFGContext();
  const { data } = useRequest(async () => await countryApi.getBelgianId());

  return (
    <>
      <FGListen
        field="clubId"
        onChanged={async (value, formik) => {
          const address = await clubApi.getClubAddress(value);
          formik.setFieldValue("clubAddress", address);
        }}
      />
      <FGListen
        field="otherAddress"
        onChanged={(value, formik) => {
          if (value) {
            formik.setFieldValue("countryId", data);
            formik.setFieldTouched("countryId", false);
          } else {
            formik.setFieldValue("countryId", null);
            formik.setFieldValue("postalCodeId", null);
            formik.setFieldTouched("countryId", false);
            formik.setFieldTouched("postalCodeId", false);
          }
        }}
      />
      <FieldGroup>
        <FieldGroup columns={2}>
          <FGTextInput name="clubAddress" label={t(ETLCodes.ClubAddress)} readonly />
        </FieldGroup>
        <FGSRSHCheckboxInput name="otherAddress" label={t(ETLCodes.OtherAddress)} />
        <FieldGroup columns={2}>
          <FGCountrySelect
            name="countryId"
            label={t(ETLCodes.Country)}
            readonly
            visible={!!formik?.values?.otherAddress}
            requiredMark
            includeBelgium={true}
          />
          <FGSelectInput
            name="postalCodeId"
            label={t(ETLCodes.City)}
            items={postCodes}
            loading={ploading}
            visible={!!formik?.values?.otherAddress}
            requiredMark
          />
        </FieldGroup>
      </FieldGroup>
    </>
  );
};
